import React from 'react';

const ServiceLetters = ({letter, services }) => (
    <li key={letter} className={`letter--select--item ${services.length === 0 && 'letter__disabled'}`}>
      {
        services.length !== 0 ?
          <a href={`#${letter}`}>{letter}</a>
          :
          letter
      }
    </li>
);

export default ServiceLetters;
